import httpClient from '../httpClient';

const sendObservations = async (id, data) => {
  return await httpClient.patch(
    `/assignments_term/${id}/add_observations/`,
    data,
  );
};

const getByTerm = async (id) => {
  return await httpClient.get(`/assignments_term/${id}/`);
};

const getUsersAssign = async (group_id, project_id) => {
  return await httpClient.get(
    `/assignments_term/get_users/?filter[rol]=${group_id}&filter[proyecto]=${project_id}`,
  );
};

export { sendObservations, getByTerm, getUsersAssign };
